import { render } from "./saveCouponsModel.vue?vue&type=template&id=57cced06"
import script from "./saveCouponsModel.vue?vue&type=script&lang=js"
export * from "./saveCouponsModel.vue?vue&type=script&lang=js"

import "./saveCouponsModel.vue?vue&type=style&index=0&id=57cced06&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__